export default "__VITE_ASSET__D$Herv27__"